import React, { useCallback, useEffect, useRef } from 'react';
import YTLoader from 'youtube-iframe';
import { groupSeek, setClientToSdk } from 'services/SyncService';
import YoutubePlayerDecorator from 'services/SyncService/YoutubePlayerDecorator';

const VIDEO = 'bmakdX5kNMM';

let sequence = [];
let timer = null;

function HLSPlayer({ isSyncRequired, isLoggedIn }) {
  const cleanup = useRef(() => {});

  const handleReady = useCallback((player) => {
    if (!player) {
      return;
    }

    window.player = player;

    setClientToSdk(new YoutubePlayerDecorator(player));

    // player.setVolume(5);

    cleanup.current = () => {
      player.destroy();
    };
  }, []);

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    const $el = document.createElement('div');
    $el.classList.add('player');
    $el.setAttribute('id', 'youtube-player');
    const $container = document.getElementById('youtube-player-container');
    $container.appendChild($el);

    sequence = [];

    YTLoader.load((YT) => {
      new YT.Player('youtube-player', {
        height: '100%',
        width: '100%',
        videoId: VIDEO,
        events: {
          onReady: (result) => {
            handleReady(result.target);
          },
          onPlaybackRateChange: (e) => {
            const $el = document.getElementById('rate-info');
            if ($el && e.data) {
              $el.innerText = Number(e.data).toFixed(2);
            }
          },
          onStateChange: (e) => {
            const type = e.data;
            console.log(`Youtube player state changed: ${type}`, YT.PlayerState);

            if (
              type === YT.PlayerState.PLAYING &&
              sequence[sequence.length - 1] === YT.PlayerState.BUFFERING &&
              !sequence.includes(YT.PlayerState.UNSTARTED)
            ) {
              sequence = [];

              if (window.sdkSeek) {
                window.sdkSeek = false;
              } else {
                groupSeek(Math.round(e.target.getCurrentTime() * 1000));
              }
            } else {
              clearTimeout(timer); // Cancel previous event
              if (type !== YT.PlayerState.BUFFERING) {
                // If we're not buffering,
                timer = setTimeout(function () {
                  // Start timer
                  sequence = [];
                }, 250);
              }
            }

            sequence = [...sequence, type];
          },
        },
        playerVars: {
          autoplay: true,
          rel: 0,
          mute: true,
          showinfo: 0,
          ecver: 2,
          playsinline: 1,
          modestbranding: false,
        },
      });
    });

    return () => {
      cleanup.current();
    };
  }, [isLoggedIn]);

  return <div id="youtube-player-container" />;
}

export default HLSPlayer;
